import { Card as AntCard, Col, Divider as AntDivider, Tag as AntTag } from 'antd';
import styled from 'styled-components';

import { Button } from '@atom/button/button';
import { Card as AtomCard } from '@atom/card/card';
import { ColorEnum } from '@enum/style/color.enum';

interface ColCardProps {
  showed: boolean;
}

export const ColCard = styled(Col)<ColCardProps>`
  display: ${(props) => (props.showed ? 'block' : 'none')};
  min-width: 280px;
  max-width: 450px;
`;

export const Card = styled(AtomCard)`
  flex: 1;
  height: 100%;

  & .ant-card-head {
    padding: 14px 0 15px 16px;
  }

  & .ant-card-body {
    padding: 0px;
  }
`;

export const ContentWrapper = styled.div`
  padding: 16px 15px 0 15px;
`;
export const CardTitle = styled(AntCard.Meta)`
  padding-top: 8px;
`;

export const Divider = styled(AntDivider)`
  margin: 8px 0;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 5px 16px 15px;
`;

export const Tag = styled(AntTag)`
  border-radius: 0 4px;
  border-color: ${ColorEnum.Wood100};
  background-color: transparent;
  padding: 0 7px;
  color: ${ColorEnum.Black100};
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
`;

export const IntegrationButton = styled(Button)`
  margin-left: auto;
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 16px;
`;
